exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".header{background-color:#f5f5f5;border-style:none;border-bottom:thin solid #d1d0cf;border-bottom-width:2px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/CompanyView.vue"],"names":[],"mappings":"AACA,QACE,yBAAqC,AACrC,kBAAmB,AACnB,iCAAkC,AAClC,uBAAyB,CAC1B","file":"CompanyView.vue","sourcesContent":["\n.header {\n  background-color: rgb(245, 245, 245);\n  border-style: none;\n  border-bottom: thin solid #d1d0cf;\n  border-bottom-width: 2px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50c30d1d","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/CompanyView.vue
// module id = 1388
// module chunks = 15